import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    viewCart: 'w-full'
  }
} satisfies RecursivePartial<DialogConfig['miniCart']>
